// THIS FILE WAS AUTOGENERATED
import Domain = require("./Domain");
import SeverityLevel = require("./SeverityLevel");
"use strict";
    
    /**
     * Instances of Message represent printf-like trace statements that are text-searched. Log4Net, NLog and other text-based log file entries are translated into intances of this type. The message does not have measurements.
     */
    class MessageData extends Domain
    {
        
        /**
         * Schema version
         */
        public ver: number;
        
        /**
         * Trace message
         */
        public message: string;
        
        /**
         * Trace severity level.
         */
        public severityLevel: SeverityLevel;
        
        /**
         * Collection of custom properties.
         */
        public properties: any;
        
        constructor()
        {
            super();
            
            this.ver = 2;
            this.properties = {};
        }
    }
export = MessageData;
